import PropTypes from "prop-types";
import * as RadixTab from "@radix-ui/react-tabs";

import "./TabGroup.css";

// -----------------------------------------------------------------------------

export default function TabGroup({
	tabList,
	activeTab,
	onChangeTab,
	onAddTab,
	onCloseTab,
	canCloseTabs,
}) {
	// -----------------------------------------------------------------------------

	// Determine label usage directly based on tab count
	const useShortLabels = tabList.length > 1;

	// -----------------------------------------------------------------------------

	return (
		// Radix root container
		<RadixTab.Root value={activeTab} onValueChange={onChangeTab}>
			{/* Experiments + Add button container */}
			<div className="tabs-container">
				{/* List of experiment tabs */}
				<RadixTab.List className="tabs-list">
					{tabList.map((tab) => (
						// Each tab
						<div
							key={tab.id}
							className={`tab ${canCloseTabs ? "can-close" : ""}`}
						>
							<RadixTab.Trigger key={tab.id} value={tab.id} className="tab-btn">
								{/* Tab label */}
								{useShortLabels && tab.shortLabel ? tab.shortLabel : tab.label}
							</RadixTab.Trigger>

							{/* Close btn */}
							<button
								className="close-tab-btn"
								type="button"
								disabled={!canCloseTabs}
								onClick={(e) => {
									// Prevent action if disabled
									if (!canCloseTabs) return;
									e.stopPropagation();
									onCloseTab(tab.id);
								}}
								// Hide from accessibility tree when not active
								aria-hidden={!canCloseTabs}
								// Prevent tabbing when hidden
								tabIndex={canCloseTabs ? 0 : -1}
								aria-label={`Close ${tab.label}`}
							>
								×
							</button>
						</div>
					))}
					{/* End of a single experiment tab */}
				</RadixTab.List>
				{/* +Add button at the end */}
				<button
					type="button"
					onClick={onAddTab}
					className="add-tab-btn"
					aria-label="Add experiment tab"
				>
					+
				</button>
			</div>

			{tabList.map((tab) => (
				<RadixTab.Content key={tab.id} value={tab.id}>
					{tab.content}
				</RadixTab.Content>
			))}
		</RadixTab.Root>
	);
}

// -----------------------------------------------------------------------------

TabGroup.propTypes = {
	tabList: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			shortLabel: PropTypes.string,
			content: PropTypes.node.isRequired,
		}),
	).isRequired,
	activeTab: PropTypes.string.isRequired,
	onChangeTab: PropTypes.func.isRequired,
	onAddTab: PropTypes.func.isRequired,
	onCloseTab: PropTypes.func.isRequired,
	canCloseTabs: PropTypes.bool.isRequired,
};
